import { MainApi } from 'api/MainApi'
import Loader from 'components/Loader/Loader'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { PROGRESS_TYPES } from 'utils/constants'

import ScenarioView from './ScenarioView/ScenarioView'

// Singleton promise cache to prevent duplicate fetches across re-mounts (Strict Mode etc.)
const scenarioPromises: Record<number, Promise<any>> = {}

const Scenario = () => {
  const { id } = useParams<{ id: string }>()
  const [loadingProgress, setLoadingProgress] = useState(PROGRESS_TYPES.IDLE)
  const [scenario, setScenario] = useState<any>(null)

  const fetchData = useCallback(
    async (background: boolean = false) => {
      const scenarioId = Number(id)
      if (isNaN(scenarioId)) return

      try {
        if (!background) {
          setLoadingProgress(PROGRESS_TYPES.WORK)
        }

        // Dedicated promise cache to catch overlapping fetches (Strict Mode etc.)
        if (!scenarioPromises[scenarioId]) {
          scenarioPromises[scenarioId] = MainApi.fetchScenario(scenarioId).finally(() => {
            // Delay deletion slightly to catch any very close overlapping calls
            setTimeout(() => {
              delete scenarioPromises[scenarioId]
            }, 100)
          })
        }

        const scenarioData = await scenarioPromises[scenarioId]
        setScenario(scenarioData)
        setLoadingProgress(PROGRESS_TYPES.SUCCESS)
      } catch (error) {
        setLoadingProgress(PROGRESS_TYPES.ERROR)
        console.warn('[Scenario] fetchData error:', error)
      }
    },
    [id]
  )

  useEffect(() => {
    fetchData()
  }, [fetchData])

  if (loadingProgress === PROGRESS_TYPES.WORK) return <Loader />
  if (loadingProgress === PROGRESS_TYPES.ERROR) return <div>Error loading scenario</div>
  if (!scenario) return null

  return <ScenarioView scenario={scenario} onUpdated={(bg?: boolean) => fetchData(bg)} />
}

export default Scenario
